import { create } from 'zustand';
import { getFocusApplications } from '../services/api';

interface Option {
  label: string;
  value: string;
}

interface FormOptionsState {
  focusApps: Option[];
  loading: boolean;
  error: string | null;
  fetchOptions: (accessToken: string) => Promise<void>;
}

export const useFormOptionsStore = create<FormOptionsState>((set) => ({
  focusApps: [],
  loading: true,
  error: null,

  fetchOptions: async (accessToken: string) => {
    try {
      const [focusAppsData] = await Promise.all([
        getFocusApplications(accessToken)
      ]);

      set({
        focusApps: focusAppsData.options || [],
        loading: false
      });
    } catch (err: any) {
      set({ error: err.message, loading: false });
    }
  }
})); 
